import { useState, useCallback } from 'react'
import { TPPInfo, ColumnVersionFull, ComparisonState } from '../types'

const useTPPChangeLogModal = () => {
    const [tppInfo, setTppInfo] = useState<TPPInfo | null>(null)
    const [selectedColumnId, setSelectedColumnId] = useState<string | null>(null)
    const [comparisonState, setComparisonState] = useState<ComparisonState | null>(null)
    const [comparisonData, setComparisonData] = useState<ColumnVersionFull | null>(null)

    const isOpen = tppInfo !== null

    const handleOpen = useCallback((info: TPPInfo, initialColumnId?: string) => {
        setTppInfo(info)
        // Default to first column if no initial column specified
        setSelectedColumnId(initialColumnId ?? info.columns[0]?._id ?? null)
    }, [])

    const handleClose = useCallback(() => {
        setTppInfo(null)
        setSelectedColumnId(null)
    }, [])

    const handleColumnChange = useCallback((columnId: string | null) => {
        setSelectedColumnId(columnId)
    }, [])

    const handleStartCompare = useCallback((state: ComparisonState) => {
        setComparisonState(state)
        // Close the modal when comparison starts
        setTppInfo(null)
        setSelectedColumnId(null)
    }, [])

    const handleStopCompare = useCallback(() => {
        setComparisonState(null)
        setComparisonData(null)
    }, [])

    const handleSetComparisonData = useCallback((data: ColumnVersionFull | null) => {
        setComparisonData(data)
    }, [])

    return {
        isOpen,
        tppInfo,
        selectedColumnId,
        handleOpen,
        handleClose,
        handleColumnChange,
        // Comparison
        comparisonState,
        comparisonData,
        handleStartCompare,
        handleStopCompare,
        handleSetComparisonData,
    }
}

export default useTPPChangeLogModal
